import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getAllMaintenance = async () => {
  const data = await axios
    .get(HOST_URL + "/Maintenance/getAll", {
      withCredentials: true,
    })
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};
export const updateMaintenance = async (Maintenance) => {
  const data = await axios
    .put(
      HOST_URL + "/Maintenance/update",
      {
        data: Maintenance,
      },
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

//add new Maintenance
export const addMaintenance = async (Maintenance) => {
  const data = await axios
    .post(
      HOST_URL + "/Maintenance/create",
      {
        data: Maintenance,
      },
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

//createProjectMaintenance
export const createProjectMaintenance = async (Maintenance) => {
  const data = await axios
    .post(
      HOST_URL + "/Maintenance/createProjectMaintenance",
      {
        data: Maintenance,
      },
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};
